var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-btn',_vm._g(_vm._b({attrs:{"fab":"","ripple":false,"fixed":""}},'app-btn',[_vm.pos, _vm.$attrs],false),_vm.$listeners),[_c('app-icon',{attrs:{"icon":_vm.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }